module.exports = __webpack_public_path__ + "img/receipt.6cf06850.png";